<template>
  <div class="co-product-images">
    <LightGallery
        :settings="{ licenseKey:'03A332BF-9CED-4313-943E-1CF4DEBD4380', speed: 500, plugins, selector : '.co-product-images__trigger' }"
        :onInit="onInit"
        :onBeforeSlide="onBeforeSlide"
        class="co-product-images__wrap"
    >
      <div class="co-product-images__preview">
        <a
          v-if="images.length"
          class="co-product-images__trigger zoomable js-zoom"
          :href="images[0].href"
          @mousemove="zoomMainImg"
          @touchmove="zoomMainImg"
          :data-src="images[0].href"
          :style="{ backgroundImage: `url(${images[0].zoom})` }"
        >
          <img :src="images[0].zoom" />
        </a>
      </div>

      <div class="co-product-images__thumbs" v-if="images.length > 1">
        <a
            class="co-product-images__thumb co-product-images__trigger"
            v-for="(item, i) in images.slice(1)"
            :key="'img' + i"
            :data-src="item.type === 'video' ? null : item.href"
            :data-poster="item.type === 'video' ? item.large_thumb : null"
            :data-sub-html="item.subHtml || null"
            :data-video="item.type === 'video' ? JSON.stringify(item.video) : null"
          >
            <img :src="item.small_thumb" alt=""/>
            <i v-if="item.type === 'video'" class="fa fa-play video-icon"></i>
          </a>
      </div>
    </LightGallery>
  </div>
</template>

<script>
import LightGallery from 'lightgallery/vue';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

export default {
  name: 'ProductGallery',
  components: {LightGallery},
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      plugins: [lgThumbnail, lgZoom, lgVideo]
    };
  },
  methods: {
    onInit() {
    },
    onBeforeSlide() {
    },
    zoomMainImg(e) {
      const zoomer = e.currentTarget;
      let offsetX, offsetY;

      if (e.offsetX !== undefined) {
        offsetX = e.offsetX;
        offsetY = e.offsetY;
      } else if (e.touches && e.touches.length) {
        const rect = zoomer.getBoundingClientRect();
        offsetX = e.touches[0].pageX - rect.left;
        offsetY = e.touches[0].pageY - rect.top;
      }

      if (offsetX !== undefined && offsetY !== undefined) {
        const x = (offsetX / zoomer.offsetWidth) * 100;
        const y = (offsetY / zoomer.offsetHeight) * 100;
        zoomer.style.backgroundPosition = `${x}% ${y}%`;
      }
    }
  }
};
</script>

<style>
@import 'lightgallery/css/lightgallery.css';
@import 'lightgallery/css/lg-thumbnail.css';
@import 'lightgallery/css/lg-zoom.css';
@import 'lightgallery/css/lg-video.css';

.co-product-images__wrap {
  display:flex;
  gap:10px;
}

.co-product-images__preview {
  display: block;
  background-size: 200%;
  background-position: center;
  width: 100%;
  order:1;
}

.co-product-images__preview a {
  display: block;
}

.co-product-images__preview img {
  width:100%;
}

.co-product-images__thumbs {
  display: flex;
  gap: 10px;
  flex-direction: column;
  width: 80px;
  flex-shrink: 0;
  order:0;
}

.co-product-images__thumbs img {
  aspect-ratio: 4 / 3;
  object-fit: cover;
  width:100%;
}

.co-product-images__thumb {
  position: relative;
  cursor: pointer;
}

.video-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2em;
  color: white;
}

@media (max-width:900px){
  .co-product-images__wrap {
    flex-direction: column;
  }

  .co-product-images__thumbs {
    flex-direction: row;
    width: 100%;
    order:1;
  }

  .co-product-images__preview {
    order:0;
  }
}


</style>
